import { EWaitlistAction, IWaitlistState, IWaitlistStep, WaitlistAction } from '../../types'

export const initialWaitlistState: IWaitlistState = {
  waitlistDraft: undefined,
  isLoading: false,
  waitlistErrors: [],
}

const waitlistReducer = (state: IWaitlistState, action: WaitlistAction): IWaitlistState => {
  switch (action.type) {
    case EWaitlistAction.SET_WAITLIST_DRAFT:
      return {
        ...state,
        waitlistDraft: action.payload,
      }

    case EWaitlistAction.CLEAR_WAITLIST_DRAFT:
      return {
        ...state,
        waitlistDraft: undefined,
      }

    case EWaitlistAction.UPDATE_FIELD: {
      if (!state.waitlistDraft?.steps) return state

      const { stepName, fieldName, fieldValue, fieldType } = action.payload
      const valueToUse = fieldType === 'checkbox' && !fieldValue ? '' : fieldValue

      const updatedSteps = state.waitlistDraft.steps.map((step) => {
        if (step.name !== stepName) return step
        return {
          ...step,
          formState: {
            ...step.formState,
            [fieldName]: valueToUse as string,
          },
        }
      }) as IWaitlistStep[]

      return {
        ...state,
        waitlistDraft: {
          ...state.waitlistDraft,
          steps: updatedSteps,
        },
      }
    }

    case EWaitlistAction.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }

    case EWaitlistAction.SET_ERROR:
      return {
        ...state,
        waitlistErrors: [...(state.waitlistErrors || []), action.payload],
      }

    case EWaitlistAction.CLEAR_ERROR:
      return {
        ...state,
        waitlistErrors: [],
      }

    default:
      return state
  }
}

export default waitlistReducer
